import { HttpClient } from './HttpClient.js';

export const ReportService = {
    reportCovenantLiquidation: async function (request) {
        return await HttpClient.postJSON(`/report/report-covenant-liquidation`, request).then(response => response)
    },
    reportGeneral: async function (request) {
        return await HttpClient.postJSON(`/report/gestiones`, request).then(response => response)
    },
    reportBatchSCL: async function (request) {
        return await HttpClient.postJSON(`/report/report-batch-scl`, request).then(response => response)
    },
    reportPayments: async function (request) {
        return await HttpClient.postJSON(`/report/reportPayments`, request).then(response => response)
    },
    reportDirections: async function (request) {
        return await HttpClient.postJSON(`/report/directions`, request).then(response => response)
    },
    reportTelephones: async function (request) {
        return await HttpClient.postJSON(`/report/reportTelephone`, request).then(response => response)
    },
    getDespachosByUser: async function(idUsuario){
        return await HttpClient.get(`/dispatch/get-by-responsible/${encodeURIComponent(idUsuario)}`).then(response => response)
    },
    getUserbyDispatchByMA: async function(idDispatch){
        return await HttpClient.get(`/user/get-by-dispatch-new/${idDispatch}`).then(response => response);
    },
    getInterntUsersByDispatch: async function(idDispatch){
        return await HttpClient.get(`/user/get-intern-dispatchs/${idDispatch}`).then(response => response);
    }
}